import { ContractConceptRelationship } from "../../../models/Entities/Contracts/ContractConceptRelationship";
import { HCVisit } from "../../../models/Entities/Protocols/HCVisit";

// store
import * as ConceptRelationshipStore from '../../../redux/middleware/ContractConceptRelationship.Middleware';
import { AppState } from "../../../redux/reducers";

interface IProps {
    visit: HCVisit;
    ContractId: number; // Assuming ContractId is needed for the modal
}
  
interface ConnectedProps {
    isLoaging: boolean;
    isSaving: boolean;
    isDeleting: boolean;
    ConceptRelationships: ContractConceptRelationship[];
}
  
  interface DispatchProps {
    getAllContractConceptRelationships: typeof ConceptRelationshipStore.actionCreators.getAllContractConceptRelationships;
  }
  
  export type Props = IProps & ConnectedProps & DispatchProps;
  
  export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    isLoaging: state.ContractConceptRelationship?.isLoadingAll || false,
    isSaving: state.ContractConceptRelationship?.isAddingNewOne || false,
    isDeleting: state.ContractConceptRelationship?.isDeletingOne || false,
    ConceptRelationships: state.ContractConceptRelationship?.list || []
  });

  export const mapDispatchToProps = {
    ...ConceptRelationshipStore.actionCreators
  };